const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:3001";

export async function registerProfile(token, { role, name }) {
  const res = await fetch(`${API_URL}/api/auth/register-profile`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ role, name }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "register-profile failed");
  return data;
}

// Asks the backend to send the BRANDED verification email (our own template
// via SMTP) instead of Firebase's default "Verify your email for edora-dc48e".
export async function resendVerificationEmail(token, language) {
  const res = await fetch(`${API_URL}/api/auth/resend-verification`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ language }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "resend-verification failed");
  return data;
}

export async function fetchMe(token) {
  const res = await fetch(`${API_URL}/api/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.error || "me failed");
  return data;
}
